import { Component, Input, OnChanges, OnInit, Optional } from '@angular/core';
import { AbstractControl, Validators } from '@angular/forms';
import { merge, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { dateToPLString } from '../../services/helpers';
import { isValidDate } from 'rxjs/internal/util/isDate';
import { CustomValidator } from '../forms/custom.validators';

@Component({
  selector: 'app-validation-errors',
  templateUrl: './validation-errors.component.html',
  imports: [
    CommonModule
  ],
  standalone: true
})
export class ValidationErrorsComponent implements OnInit, OnChanges {

  @Input()
  showTextLength: boolean = false;

  @Input()
  maxTextLength: number = 5000;

  @Input()
  control: AbstractControl | null = null;

  @Input()
  fieldLabel: string = '';

  @Input()
  secondFieldLabel: string = '';

  @Input()
  minDate: Date | null = null;

  public controlForm: AbstractControl | undefined;
  public error$: Observable<any> | undefined;

  private errorsMessages: any;

  constructor() {
  }

  private setError(control: AbstractControl): void {
    this.controlForm = control;
    this.error$ = merge(of(null), control.statusChanges).pipe(
      map(() => {
        const errorKeys = Object.keys(control.errors || {});
        if ((!control.errors)) {
          return null;
        }
        if (!!control.errors[errorKeys[0]] && control.errors[errorKeys[0]] !== true && !control.errors[errorKeys[0]]?.requiredMask) {
          const desc = this.prepareDescription(control.errors[errorKeys[0]]);
          return desc ? `${this.errorsMessages[errorKeys[0]]}: ${desc}` : this.errorsMessages[errorKeys[0]];
        }
        return this.errorsMessages[errorKeys[0]];
      })
    );
  }

  private prepareDescription(desc: any): string | null {
    switch (true) {
      case typeof desc === 'object' && isValidDate(desc): {
        return dateToPLString(desc) || '';
      }
      case typeof desc === 'object' && this.showTextLength: {
        return desc?.requiredLength || desc;
      }
      default: {
        return null;
      }
    }
  }

  public ngOnChanges(): void {
    if (this.control) {
      this.setError(this.control);
    }
  }

  public ngOnInit(): void {
    // @ts-ignore
    this.errorsMessages = {
      min: 'Niepoprawna wartość',
      phone: 'Niepoprawny numer telefonu',
      email: 'Podany adres e-mail jest nieprawidłowy',
      matchPassword: 'Powtórzone hasło nie pasuje',
      otherPassword: 'Nowe hasło musi być inne niż aktualne',
      invalidDate: 'Niepoprawny format daty! (poprawny format: dd.mm.rrrr)',
      maxDate: 'Podana data powinna być wcześniejsza niż',
      minDate: 'Podana data powinna być późniejsza niż',
      password: 'Niepoprawne hasło',
      pin: 'Pin jest niepoprawny',
      pesel: 'PESEL jest nieprawidłowy',
      required: `Pole jest wymagane.`,
      maxlength: 'Przekroczono maksymalną liczbę znaków',
      minlength: 'Minimalna liczba znaków',
      forbiddenName: 'Niepoprawna wartość',
      isNumber: 'Niepoprawna wartość - wymagana liczba',
      nip: 'Niepoprawny NIP',
      regon: 'Niepoprawny REGON',
      fromToDate: `${this.fieldLabel || 'Pole X'} powinna być późniejsza lub równa ${this.secondFieldLabel || 'Pole Y'}`,
      fromToTime: `${this.fieldLabel || 'Pole X'} powinna być późniejsza niż ${this.secondFieldLabel || 'Pole Y'}`,
      unique: 'Wartość już została wybrana',
      includesName: 'Hasło zawiera część/lub imię użytkownika',
      includesUsername: 'Hasło zawiera część/lub nazwę użytkownika',
      notIncludesNumber: 'Hasło musi zawierać co najmniej jedną cyfrę',
      uppercase: 'Hasło musi zawierać co najmniej jedną wielką literę',
      lowercase: 'Hasło musi zawierać co najmniej jedną małą literę',
      passwordMinLength: `Hasło musi składać się z minimum 8 znaków`,
      specialChar: 'Hasło musi zawierać co najmniej jeden znak specjalny',
      mask: 'Podana niepoprawna wartośc',
      locationRequired: 'Wskaż lokalizacje',
      borderOnly: '',
      invalidBankAccountNumber: 'Nieprawidłowy numer konta bankowego'
    };
  }
}
